import {
  OreStack,
  OreTable,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createApiContractRepository } from '@/Contract/infrastructure'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { useProductsDataController } from '@/Contract/ui/hooks'
import { ContractPaymentMethodPill } from '@/Contract/ui/molecules'
import { useUserData } from '@/User/ui/context'

export const ContractBillingSummaryCard = (): JSX.Element => {
  const { t } = useTranslation()
  const { userProducts, merchant } = useUserData()

  const { model } = useProductsDataController(
    merchant.id,
    createApiContractRepository(),
    [userProducts[0].productCode],
  )

  return (
    <OreTableContainer>
      <OreTable>
        <OreTableCaption title={t(contractTranslation.productsData.summary.title)} />
        <OreTableBody>
          <OreTableRow>
            <OreTableCell align="left">
              <OreText align="left">
                {t(contractTranslation.productsData.summary.paymentMethod)}
              </OreText>
            </OreTableCell>
            <OreTableCell align="right">
              {model && model.length > 0 ? (
                <OreStack placeContent="end">
                  <ContractPaymentMethodPill state={model[0].paymentModeId ?? 1} />
                </OreStack>
              ) : null}
            </OreTableCell>
          </OreTableRow>
          <OreTableRow>
            <OreTableCell align="left">
              <OreText align="left">
                {t(contractTranslation.productsData.summary.chargeDate)}
              </OreText>
            </OreTableCell>
            <OreTableCell align="right">
              <OreText align="right" bold>
                {model && model.length > 0 ? model[0].paymentTermName : null}
              </OreText>
            </OreTableCell>
          </OreTableRow>
          <OreTableRow>
            <OreTableCell align="left">
              <OreText align="left">
                {t(contractTranslation.productsData.summary.billingType)}
              </OreText>
            </OreTableCell>
            <OreTableCell align="right">
              <OreText align="right" bold>
                {model && model.length > 0
                  ? model[0].isElectronicInvoice
                    ? t(contractTranslation.productsData.summary.types.electronic)
                    : t(contractTranslation.productsData.summary.types.paper)
                  : null}
              </OreText>
            </OreTableCell>
          </OreTableRow>
        </OreTableBody>
      </OreTable>
    </OreTableContainer>
  )
}
